// ═══════════════════════════════════════════════════════════════════════════════
// Weather greeting sub-heading — system-wide HKO + AI cache
// ═══════════════════════════════════════════════════════════════════════════════
import { USAGE_REGION } from './usageRegion.js';
export const WEATHER_GREETING_CACHE_HOURS = 2;
export const WEATHER_GREETING_STALE_MAX_HOURS = 5;
export const WEATHER_GREETING_RETENTION_DAYS = 30;
export const WEATHER_GREETING_VARIANT_COUNT = 3;
export const WEATHER_GREETING_SUPPORTED_LANGUAGES = ['zh-Hant', 'zh-Hans', 'en', 'id', 'fil'];
/** Latin-script weather lines (en / id / fil) share the same character limits. */
export const WEATHER_GREETING_LATIN_LANGUAGES = ['en', 'id', 'fil'];
export const isWeatherGreetingLatinLanguage = (language) => WEATHER_GREETING_LATIN_LANGUAGES.includes(language);
export const WEATHER_GREETING_ELIGIBLE_REGIONS = [
    USAGE_REGION.HK,
    USAGE_REGION.MO,
];
export const WEATHER_GREETING_ZH_MIN_CHARS = 30;
export const WEATHER_GREETING_ZH_MAX_CHARS = 50;
export const WEATHER_GREETING_EN_MIN_CHARS = 100;
export const WEATHER_GREETING_EN_MAX_CHARS = 140;
export const WEATHER_GREETING_GEMINI_VALIDATION_RETRIES = 3;
export const WEATHER_GREETING_GEMINI_TIMEOUT_SECONDS = 60;
export const isWeatherGreetingEligibleRegion = (region) => WEATHER_GREETING_ELIGIBLE_REGIONS.includes(region);
//# sourceMappingURL=weatherGreeting.js.map